import { render, staticRenderFns } from "./index.bilibili.vue?vue&type=template&id=6c34f06e"
import script from "./index.bilibili.vue?vue&type=script&lang=js"
export * from "./index.bilibili.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports